import React from 'react';
import { Divider, Breakpoint } from '@moda/om';
import { noop } from '@moda/portal-stanchions';
import { PasswordSignIn } from './PasswordSignIn';
import { Guest } from './Guest';
import { CheckoutSocialAuthButtons } from './CheckoutSocialAuthButtons';

import './Authentication.scss';
import './CheckoutAuthentication.scss';

export const PasswordCheckoutAuthentication: React.FC = () => {
  return (
    <div className="CheckoutAuthentication">
      <>
        <div className="CheckoutAuthentication__section">
          <Guest onAuth={noop} />
          <Breakpoint lt="sm">
            <Divider />
          </Breakpoint>
        </div>
        <div className="CheckoutAuthentication__section">
          <PasswordSignIn
            title="Returning Customers"
            message="Please sign in for a quicker checkout experience."
            showSocialAuth={false}
            showCancelButton={false}
            onAuth={noop}
          />
          <CheckoutSocialAuthButtons />
        </div>
      </>
    </div>
  );
};
